<template>
    <div>
        <trip-note v-for="note of trip.notes" :key="note.id" :note="note"></trip-note>
        <!--<div v-if="!addingNote">-->
        <template v-if="!addingNote">
            <i @click="addNote" class="fa fa-plus"></i>
        </template>
        <!--</div>-->
        <template v-else>
        <!--<div v-else>-->
            <div style="display: flex; margin-top: 10px;">
                <trip-note v-if="addingNote" :note="newNote" @change="newNote.note = $event" @enter="submitNote" style="flex-grow: 1;"></trip-note>
                <button class="success" style="margin-top: 0; margin-left: 2px" @click="submitNote">
                    <i class="fa fa-check"></i>
                </button>
                <button class="dangerous" style="margin-top: 0; margin-left: 2px" @click="cancelNote">
                    <i class="fa fa-ban"></i>
                </button>
            </div>
        </template>
        <!--</div>-->
    </div>
</template>

<script>
    import TripNote from './TripNote.vue'

    export default {
      data () {
        return {
          newNote: {
            note: ''
          },
          addingNote: false
        }
      },
      props: [
        'trip'
      ],
      components: {
          'trip-note': TripNote
      },
      methods: {
        addNote () {
          this.addingNote = true
        },
        cancelNote () {
          this.addingNote = false
        },
        submitNote () {
          this.$eventHub.$emit('createTripNote', {
            trip_id: this.trip.id,
            note: this.newNote.note,
            stock_num: this.trip.stock_num
          })
          this.newNote.note = ''
          this.addingNote = false
        }
      },
    }
</script>

<style lang="less" scoped>
    .note {
        margin-bottom: 10px;
    }
    .fa-plus {
        color: #0074d9
    }
</style>